const store = {
    namespaced: true,
    state: {
        pagination: {
            current_page: null,
            total_pages: null,
        },
        filter: {
            shortcut_keys: [
                "staff_identity",
            ],
            current_shortcut_key: "staff_identity",
            init_columns: {
                page: 1,
                staff_identity: null,
                driver_commission_policy_identity: null,
                amount: null,
                polarity: null,
            },
            columns: {},
        },
        driver_commissions: [],
        staffs: [],
    },
    getters: {
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let columns = _.cloneDeep(state.filter.columns)
            if (columns.page) delete columns.page
            return object_delete_null(columns)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload) => {
                let columns = _.cloneDeep(state.filter.columns)
                return object_to_query(columns)
            }
        },
    },
    actions: {
        fetch_staffs(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_staffs).parse(
                {},
                "?" + object_to_query({
                    pagination: false
                })
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_staffs', response.data.staffs)
                })
                .catch(error => {
                    console.log('Failed to fetch Roles.')
                    return Promise.reject(error)
                })
        },
        fetch_driver_commissions(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_driver_commissions).parse(
                {},
            )
            let api_query = context.getters.filter_to_api_query()
            if (api_query) url += `?${api_query}`

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_driver_commissions', response.data.driver_commissions)
                        context.commit('set_pagination', response.data.pagination)
                    } else if (response.data.status == 'failure') {
                        return Promise.reject('fetch fetch_driver_commissions failure')
                    }
                })
                .catch(error => {
                    console.log('fetch fetch_driver_commissions failure')
                    return Promise.reject(error)
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter.init_columns), ...payload.query}
                context.state.filter.columns = {...context.state.filter.columns, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let columns = object_delete_null(
                _.cloneDeep(context.state.filter.columns)
            )

            if (columns.page) delete columns.page
            if (columns.staff_identity) {
                context.state.filter.is_show = true
            }
        },
    },
    mutations: {
        set_driver_commissions(state, payload) {
            state.driver_commissions = payload
        },
        set_staffs(state, payload) {
            state.staffs = payload
        },
        set_pagination(state, payload) {
            state.pagination = payload
        },
        init_filter_columns(state, payload) {
            state.filter.columns = _.cloneDeep(state.filter.init_columns)
        }
    }
}

export default store
